import { get, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getPosEntryModeList = () => get(url.POS_ENTRY_MODE_GET)
export const updatePosEntryMode = record => put(url.POS_ENTRY_MODE_UPDATE, record)